export default "__VITE_ASSET__6ae98059__"